import React, {Component} from "react"
import {Row} from "@irati/ui/src/Layout"

import {officesForTenant} from "@irati/identity/utils/tenant/hasMultipleOffices"
import {Select} from "@irati/ui/src/FormItem"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

interface Option {
  value: string
  label: string
}

interface Props extends InjectIntl {
  id?: string
  onChange: (regionId: string) => void
  value: string
  isDisabled?: boolean
}

interface State {
  regionOptions: Option[]
}

export const ALL_TEAMS = "ALL"

class Region extends Component<Props, State> {
  state = {
    regionOptions: []
  }

  async componentDidMount() {
    const {formatMessage} = this.props

    const businessUnits = await officesForTenant()
    const regionOptions = [
      {
        label: formatMessage({id: "admin.reporting.countriesMultiSelect.defaultLabel"}),
        value: ALL_TEAMS
      },
      ...businessUnits.map((team) => ({
        label: team.teamName.replace("platform.billingUnit.", ""),
        value: team.uuid,
        regionId: team?.regionId
      }))
    ]
    this.setState({regionOptions})
  }

  render() {
    const {value, onChange, isDisabled, id} = this.props
    const {regionOptions} = this.state

    return (
      <Row>
        <Select id={id} options={regionOptions} isDisabled={isDisabled} value={value} onChange={onChange} />
      </Row>
    )
  }
}

export default injectIntl(Region)
